<template>
  <el-card v-if="isSticker" class="card linkInfoSection">
    <div slot="header">
      <strong class="linkInfoSection__title">stickers 配置</strong>
    </div>
    <div class="stickerReadonly__meta">
      <div>stickers type: {{ typeLabel }}</div>
      <div>设计师：{{ designerLabel }}</div>
    </div>
    <p v-if="packTagText" class="stickerReadonly__packTags">包标签：{{ packTagText }}</p>
    <p
      v-if="statusNote && Number(info.onOrOff) !== 11"
      class="stickerReadonly__note"
    >{{ statusNote }}</p>
    <p
      v-else-if="Number(info.onOrOff) === 11"
      class="stickerReadonly__note stickerReadonly__note--bad"
    >{{ statusError || statusNote || info.comment || '处理失败' }}</p>
    <sticker-strip :cards="cards" :replaceable="false" />
    <p v-if="!cards.length && Number(info.onOrOff) !== 11" class="stickerReadonly__note">还没有 stickers。</p>
  </el-card>
</template>

<script>
import StickerStrip from './form/basicForms/StickerStrip.vue'
import { stickerCards, stickerTypeLabel } from './form/stickerExtaCards'
import {
  stickerInitializationError,
  stickerInitializationMessage,
} from './form/stickerInitialization'
import { listStickerTags } from '../../../api/genericResource'

export default {
  name: 'GenericResourceStickerReadonly',
  components: { StickerStrip },
  props: {
    info: { type: Object, required: true },
  },
  data() {
    return {
      tagBindings: [],
      tagRequestId: 0,
    }
  },
  computed: {
    isSticker() {
      return this.info.assetType === 'stickers' || this.info.wallpaperType === 'stickers'
    },
    exta() {
      return (this.info.jsonConfig && this.info.jsonConfig.exta) || null
    },
    typeLabel() {
      return stickerTypeLabel(this.exta)
    },
    designerLabel() {
      return this.info.authorName || '—'
    },
    cards() {
      const byItem = {}
      this.tagBindings.forEach((tag) => {
        const id = tag.itemId || ''
        if (!id) return
        if (!byItem[id]) byItem[id] = []
        byItem[id].push(tag)
      })
      return stickerCards(this.exta).map((card) => ({
        ...card,
        tags: byItem[card.id] || [],
      }))
    },
    packTagText() {
      return this.tagBindings
        .filter((tag) => !tag.itemId)
        .map((tag) => tag.name)
        .filter(Boolean)
        .join('、')
    },
    statusNote() {
      return stickerInitializationMessage(this.info)
    },
    statusError() {
      return stickerInitializationError(this.info)
    },
  },
  watch: {
    'info.id': {
      immediate: true,
      handler(id) {
        this.loadTags(id)
      },
    },
  },
  methods: {
    loadTags(id) {
      this.tagBindings = []
      if (!id || !this.isSticker) return
      const requestId = ++this.tagRequestId
      listStickerTags(id)
        .then((res) => {
          if (requestId !== this.tagRequestId) return
          this.tagBindings = (res && res.data) || []
        })
        .catch(() => {
          if (requestId !== this.tagRequestId) return
          this.tagBindings = []
        })
    },
  },
}
</script>

<style scoped>
.stickerReadonly__meta {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px 40px;
  margin-bottom: 8px;
}
.stickerReadonly__packTags {
  margin: 0 0 8px;
  text-align: center;
  color: #57534e;
  font-size: 13px;
  line-height: 1.4;
}
.stickerReadonly__note {
  margin: 8px 0 0;
  color: #57534e;
}
.stickerReadonly__note--bad {
  color: #b91c1c;
}
</style>
